import {Box, makeStyles, Button, Grid, Typography} from "@material-ui/core";
import {useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import {useDispatch, useSelector} from "react-redux";
import TopBar from "../../components/Common/TopBar";
import SearchActionsSection from "../../components/DriverEfficiencyMonitor/SearchActionsSection";
import TableSection from "../../components/DriverEfficiencyMonitor/TableSection";
import {showAlertSnackbar} from "../../reducers/uiSlice";
import {useToken} from "../../utilities/hooks";
import _ from 'lodash';
import {getDeliveryReport, getUserTeam, getAlertRule, downloadDriverEfficiencyExcelBlob} from "../../actions/deliveryEfficiencyMonitorAction";
import {getUserPreference} from "../../utilities/common";
import UniDialog from "../../components/Common/UniDialog";
import {downloadZipCodeExcelBlob} from "../../actions/deliveryAreaActions";

const useStyles = makeStyles((theme) => ({
    root: {
        backgroundColor: theme.palette.background.default,
        display: 'flex',
        flexDirection: 'column',
        margin: 0
    },
    appBarClasses: {
        backgroundColor: theme.palette.background.default,
        color: theme.palette.text.primary,
        padding: theme.spacing(1)
    },
    topBarButton: {
        marginLeft: theme.spacing(2),
        color: 'unset',
        '&:hover': {
            color: theme.palette.text.primary
        }
    },
    buttonGroupStyle: {
        textAlign: 'right',
        marginTop: theme.spacing(3),
        marginBottom: theme.spacing(2)
    }
}))

function DriverEfficiencyMonitor(props) {
    const dispatch = useDispatch();
    const classes = useStyles();
    const {t} = useTranslation('driverEfficiencyMonitor');
    const tokenContents = useToken();
    const authorizedWarehouses = tokenContents.warehouse;
    const [isDataLoading, setIsDataLoading] = useState(false);
    const [teamList, setTeamList] = useState([]);
    const [page, setPage] = useState(0);
    const [allDriverDetails, setAllDriverDetails] = useState([]);
    const [selected, setSelected] = useState('');
    const [selectedType, setSelectedType] = useState('');
    const [selectedInput, setSelectedInput] = useState('');
    const [selectedDrivers, setSelectedDrivers] = useState();
    const [selectedTeam, setSelectedTeam] = useState(0);
    const [selectedPartner, setSelectedPartner] = useState('');
    const [alertRule, setAlertRule] = useState([]);
    const [completionRule, setCompletionRule] = useState([]);
    const [inactiveRule, setInactiveRule] = useState([]);
    const [selectedExpress, setSelectedExpress] = useState(null);
    const [partnerList, setPartnerList] = useState([]);
    const userPref = getUserPreference();
    const [loading, setLoading] = useState(false);
    const [openDownLoadDialog, setOpenDownLoadDialog] = useState(false);

    const handleSelectedItems = (items) => {
        setSelected(items);
    }
    const handleSelectedSearchType = (searchType) => {
        setSelectedType(searchType)
    }
    const handleSelectedInput = (input) => {
        setSelectedInput(input)
    }
    const handleSelectedDriversInput = (input) => {
        setSelectedDrivers(input)
    }
    const handleSelectedTeam = (team) => {
        setSelectedTeam(team)
    }
    const handlePageChange = (newPage) => {
        setPage(newPage);
    }
    const handleSelectPartner = (parnter) => {
        setSelectedPartner(parnter);
        if (!_.isEmpty(allDriverDetails)) {
            setIsDataLoading(true);
            getDriverReport(parnter, selectedExpress)
        }
    }
    const handleDownloadResult = () => {
        setOpenDownLoadDialog(true)
    }
    const handleSelectExpress = (express) => {
        if (express === true)
            setSelectedExpress(1);
        else
            setSelectedExpress(0);
    }
    const handleDriverDetailSearch = () => {
        setIsDataLoading(true);
        setSelectedExpress(null);
        setSelectedPartner('');
        getDriverReport()
    }
    const handleDataLoading = (state) => {
        setIsDataLoading(state);
    }

    useEffect(() => {
        if (!_.isNil(selectedExpress) && !_.isEmpty(allDriverDetails)) {
            setIsDataLoading(true);
            getDriverReport(0, selectedExpress)
        }
    }, [selectedExpress])

    useEffect(() => {
        dispatch(getUserTeam(userPref.userId, userPref.userCity)).then((res) => {
            setTeamList(res);
        }).catch(() => {
            setLoading(false);
        })

        dispatch(getAlertRule()).then((res) => {
            setAlertRule(res);
            setCompletionRule(tableAlertReGroup(res, 1));
            setInactiveRule(tableAlertReGroup(res, 2));
        }).catch(() => {
            setLoading(false);
        })
    }, []);

    return (
        <Box className={classes.root}>
            <TopBar
                title={t('delivery_monitoring')}
                appBarClasses={classes.appBarClasses}
            />
            <SearchActionsSection
                teamList={teamList}
                onSearch={handleDriverDetailSearch}
                handleSelectedSearchType={handleSelectedSearchType}
                handleSelectedInput={handleSelectedInput}
                handleSelectedTeam={handleSelectedTeam}
                selectedTeam={selectedTeam}
                selectedInput={selectedInput}
                selectedDrivers={selectedDrivers}
                selectedType={selectedType}
                isDataLoading={isDataLoading}
                handleSelectedDriversInput={handleSelectedDriversInput}
            />
            <TableSection
                setPage={handlePageChange}
                setSelectedItems={handleSelectedItems}
                page={page}
                isDataLoading={isDataLoading}
                allDriverDetails={allDriverDetails}
                partnerList={partnerList}
                selectedType={selectedType}
                selectedInput={selectedInput}
                selectedTeam={selectedTeam}
                handleSelectPartner={handleSelectPartner}
                handleSelectExpress={handleSelectExpress}
                selectedExpress={selectedExpress}
                selectedPartner={selectedPartner}
                completionRules={completionRule}
                inactiveRule={inactiveRule}
                handleDataLoading={handleDataLoading}
                handleDownloadResult={handleDownloadResult}
            />
            <UniDialog
                open={openDownLoadDialog}
                onClose={() => {
                    setOpenDownLoadDialog(false)
                }}
                maxWidth='sm'
                fullWidth
                disableDefaultButtons
                title={t('download_title')}
            >
                <Grid container spacing={1}>
                    <Grid item xs={8}>
                        <Typography variant='body2'>
                            <span className={classes.labelTitle}>{t('batch_number')}: </span>
                            {selectedInput || "N/A"}
                        </Typography>
                    </Grid>
                    <Grid item xs={8}>
                        <Typography variant='body2'>
                            <span className={classes.labelTitle}>{t('driver_id')}: </span>
                            {selectedDrivers || "N/A"}
                        </Typography>
                    </Grid>
                    <Grid item xs={8}>
                        <Typography variant='body2'>
                            <span className={classes.labelTitle}>{t('team')}: </span>
                            {selectedTeam || "N/A"}
                        </Typography>
                    </Grid>
                    <Grid item xs={8}>
                        <Typography variant='body2'>
                            <span className={classes.labelTitle}>{t('express')}: </span>
                            {selectedExpress === 1 ? (t('yes')) : (t('no'))}
                        </Typography>
                    </Grid>
                    <Grid item xs={8}>
                        <Typography variant='body2'>
                            <span className={classes.labelTitle}>{t('partner')}: </span>
                            {selectedPartner || "N/A"}
                        </Typography>
                    </Grid>
                </Grid>
                <div className={classes.buttonGroupStyle}>
                    <Button
                        id='driverefficiencymonitor-canceldownload-button'
                        onClick={() => {
                            setOpenDownLoadDialog(false)
                        }} autoFocus>
                        {t('cancel')}
                    </Button>
                    <Button
                        id='driverefficiencymonitor-confirmeddownload-button'
                        color='primary'
                        variant='contained'
                        onClick={() => {
                            setOpenDownLoadDialog(false)
                            getDriverReport(selectedPartner, selectedExpress, true)
                        }}
                    >
                        {t('confirmed')}
                    </Button>
                </div>
            </UniDialog>
        </Box>
    );

    function getDriverReport(partnerId = 0, isExpress = null, download = false) {
        let params = {}
        params = {
            sub_references: selectedInput,
            driver_ids: selectedDrivers,
            team_id: selectedTeam,
            is_express: isExpress
        }
        if (partnerId > 0) {
            _.merge(params, {partner_id: partnerId})
        }
        if (!download) {
            dispatch(getDeliveryReport(params)).then((res) => {
                if (_.isEmpty(res)) {
                    dispatch(showAlertSnackbar({message: "No Data Found", type: 'error'}))
                } else {
                    setAllDriverDetails(res);
                    setPartnerList(res.partner_list)
                }
            })
                .catch((err) => {
                    dispatch(showAlertSnackbar({message: "Please check input data or contact admin", type: 'error'}))
                })
                .finally(() => {
                    setIsDataLoading(false);
                })
        } else {
            downloadDriverEfficiencyExcelBlob(params)
                .catch((error) => {
                    if (error?.status === 200) {
                        dispatch(showAlertSnackbar({message: t('no_data'), type: 'warning'}))
                    } else {
                        dispatch(showAlertSnackbar({message: t('fetch_error'), type: 'error'}))
                    }
                })
                .finally(() => {
                    setIsDataLoading(false);
                })
        }
    }
    function tableAlertReGroup(res, type) {
        let result = _.filter(
            res, (item) => {
                return item.type === type;
            })
        if (!_.isEmpty(result))
            return result;
        else return false;
    }
}

export default DriverEfficiencyMonitor;